import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Tabs, Pagination, Divider } from 'antd'
import Comment from 'components/Comment'
import moment from 'moment'
import styles from './index.scss'

const TabPane = Tabs.TabPane

const tabMap = {
  SystemNotice: '系统通知',
  FeedBack: '反馈建议',
  UserMessage: '我的消息',
}

class UHistory extends ComponentExt {
  state = {
    current: 'SystemNotice',
    tabList: ['SystemNotice', 'FeedBack', 'UserMessage'],
    msgData: { data: [], total: 0 },
    pageindex: 1,
    collectModal: false,
  }

  componentDidMount() {
    this.fetchUserSystemNoticeList(1)
  }

  async fetchUserSystemNoticeList(pageindex) {
    const res = await this.api.user.getSystemNoticeList({
      pageindex,
      pagesize: 15,
    })
    this.setState({
      msgData: res,
    })
  }

  async fetchUserMessageList(pageindex) {
    const res = await this.api.user.unRead({ pageindex, pagesize: 15 })

    this.setState({
      msgData: res,
    })
  }

  async fetchFeedBackList(pageindex) {
    const res = await this.api.feedback.getFeedbackList({
      pageindex,
      pagesize: 15,
    })
    this.setState({
      msgData: res,
    })
  }

  handlePageChange(index) {
    this.setState({
      pageindex: index,
    })
  }

  handleTabClick(e) {
    switch (tabMap[e]) {
      case '系统通知':
        this.fetchUserSystemNoticeList(1)
        break
      case '反馈建议':
        this.fetchFeedBackList(1)
        break
      case '我的消息':
        this.fetchUserMessageList(1)
    }
    this.setState({
      current: e,
      pageindex: 1,
    })
  }

  renderHandleBar = () => {
    const { tabList, current } = this.state

    return (
      <Tabs activeKey={current} onChange={e => this.handleTabClick(e)}>
        {tabList.map(tab => <TabPane tab={`${tabMap[tab]}`} key={tab} />)}
      </Tabs>
    )
  }

  renderSystemNotice = () => {
    const { msgData } = this.state

    return msgData.total > 0 ? (
      msgData.data.map(msg => (
        <li key={msg.created_at}>
          {msg.head_url && (
            <img className={styles.avatar} src={msg.head_url} alt="" />
          )}
          <div className={styles.content}>
            <h6 className={styles.msgName}>{msg.title}</h6>
            <p className={styles.msgTime}>
              {moment((msg.created_at || msg.created) * 1000).format(
                'YYYY-MM-DD',
              )}
            </p>
            <p className={styles.msgText}>{msg.content}</p>
          </div>
        </li>
      ))
    ) : (
      <li style={{ width: '100%', textAlign: 'center' }}>暂无数据</li>
    )
  }

  renderFeedBack = () => {
    const { msgData } = this.state

    return msgData.total > 0 ? (
      msgData.data.map((item, idx) => (
        <li key={`li${idx}`}>
          <Comment
            avatar={item.head_url}
            name={item.user_name}
            content={item.content}
            pics={item.img_url}
            time={item.created}
            response={item.customer_service_answer}
          />
        </li>
      ))
    ) : (
      <li style={{ width: '100%', textAlign: 'center' }}>暂无数据</li>
    )
  }
  render() {
    const { msgData, current, pageindex } = this.state
    return (
      <div className={styles.userMessage}>
        <h3 className={styles.handleBar}>{this.renderHandleBar()}</h3>
        <section style={{ backgroundColor: '#fff', padding: '0 0 32px' }}>
          <ul className={styles.messageList}>
            {current === 'SystemNotice'
              ? this.renderSystemNotice()
              : this.renderFeedBack()}
          </ul>
          <div style={{ textAlign: 'center', marginTop: '49px' }}>
            <Pagination
              hideOnSinglePage={true}
              total={msgData.total}
              current={pageindex}
              onChange={this.handlePageChange}
              defaultPageSize={16}
            />
          </div>
        </section>
      </div>
    )
  }
}

export default UHistory
